import React from "react";
import { Tag } from "react-feather";
import toast from "react-hot-toast";
import { useLazyGetStockQrCodeQuery } from "../../../stock/stockApi";
import { composeQrImage, printComposedImage } from "../../customers/qrImageUtils";

// Generic per-product barcode/QR label - reuses the same /stock/qrcode
// endpoint and print-compose utility as Stock-In's per-batch "Print Barcode
// Label" (StockInDetail.jsx), but with no customBarcodeValue, so the API
// falls back to its own generic PRD:{branchId}:{productCode} content
// (StockService.GenerateQrCodeBytesAsync) instead of a specific received
// batch's barcode. No new endpoint/DB - this content shape already existed
// server-side, it just wasn't wired to the product master UI.
const ProductBarcodeButton = ({ branchId, productCode, productName, variant = "icon" }) => {
  const [triggerQr, { isFetching }] = useLazyGetStockQrCodeQuery();

  const handlePrint = async (e) => {
    e?.stopPropagation();
    try {
      const { data: blob } = await triggerQr({ branchId, productCode });
      if (!blob) return toast.error("Could not generate the barcode");
      const url = await composeQrImage(blob, { title: productName, subtitle: `Code: ${productCode}` });
      printComposedImage(url, productName);
    } catch {
      toast.error("Could not generate the barcode");
    }
  };

  if (variant === "button") {
    return (
      <button type="button" className="btn btn-outline-primary" onClick={handlePrint} disabled={isFetching}>
        <Tag size={16} className="me-2" />
        Print Barcode
      </button>
    );
  }

  return (
    <button type="button" className="btn btn-link p-1" title="Print Barcode / QR Code" onClick={handlePrint} disabled={isFetching}>
      <Tag size={15} />
    </button>
  );
};

export default ProductBarcodeButton;
